import React from 'react';
import Button from '../primitives/Button';
import Heading from '../primitives/Heading';
import Typography from '../primitives/Typography';

export type SectionHeaderWithButtonProps = {
  title: React.ReactNode;
  description?: React.ReactNode;
  subheading?: string;
  buttonText?: string;
  buttonHref?: string;
  buttonOnClick?: () => void;
  buttonVariant?: 'primary' | 'secondary' | 'link';
  buttonSize?: 'sm' | 'md' | 'lg';
  className?: string;
};

const SectionHeaderWithButton: React.FC<SectionHeaderWithButtonProps> = ({
  title,
  description,
  subheading,
  buttonText,
  buttonHref,
  buttonOnClick,
  buttonVariant = 'primary',
  buttonSize = 'md',
  className = '',
}) => {
  return (
    <div className={`flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8 ${className}`}>
      <div className="flex-1">
        <Heading as="h2" size="lg" className="mb-2">
          {title}
        </Heading>
        {description && (
          <Typography variant="body-lg" color="muted">
            {description}
          </Typography>
        )}
      </div>
      {buttonText && (
        <div className="flex-shrink-0">
          {buttonHref ? (
            <a href={buttonHref} target="_blank" rel="noopener noreferrer">
              <Button variant={buttonVariant} size={buttonSize}>
                {buttonText}
              </Button>
            </a>
          ) : buttonOnClick ? (
            <Button variant={buttonVariant} size={buttonSize} onClick={buttonOnClick}>
              {buttonText}
            </Button>
          ) : (
            <Button variant={buttonVariant} size={buttonSize}>
              {buttonText}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default SectionHeaderWithButton; 